export enum HublerNetworkApplicationStatus {
  NOT_STARTED = 'NOT_STARTED',
  INCOMPLETE = 'INCOMPLETE',
  MISSING_DOCUMENTS = 'MISSING_DOCUMENTS',
  COMPLETE = 'COMPLETE',
  SENT = 'SENT',
}
